import { verifyClubPremierNumber } from '../../../utilities/form-helpers';
import regexMap from '../../../constants/regex-map';

const isAtLeastOneUpperCase = value => regexMap.AT_LEAST_ONE_UPPERCASE.test(value);
const isCombinationNumbersLetters = value => regexMap.IS_COMBINATION_LETTERS_NUMBERS.test(value);
const isEmpty = value => value === undefined || value === null || value === '';
const isInteger = value => Number.isInteger(Number(value));
const isSpecialCharcaters = value => !regexMap.ALPHANUMERIC_ONLY.test(value);

/**
 * @param {String} value - club premier number entered
 */
export function clubPremierNumber(value) {
  const trimmedVal = value && value.replace(/\s/g, '');

  if (isEmpty(trimmedVal)) {
    return 'APP_VALIDATION_CLUB_PREMIER_EMPTY'; // Please provide a valid club premier number
  } else if (!isInteger(trimmedVal) || trimmedVal.length < 9 || trimmedVal.length > 9) {
    return 'APP_VALIDATION_CLUB_PREMIER_NUMBER'; // The data has to be numbers and 11 digits
  } else if (!verifyClubPremierNumber(trimmedVal)) {
    return 'APP_VALIDATION_CLUB_PREMIER_FAILURE';
  }
}

export function checkNewPasswordValidations(value) {
  if (value && value.length < 8 || !isCombinationNumbersLetters(value)) {
    return 'PRO_HOME_NEW_PASSWORD_ERROR_GENERAL';
  } else if (value && value.length > 0 && isSpecialCharcaters(value)) {
    return 'PRO_HOME_NEW_PASSWORD_ERROR_SPECIAL';
  } else if (!isAtLeastOneUpperCase(value)) {
    return 'PRO_HOME_NEW_PASSWORD_ERROR_CAPITAL';
  }
}

export function confirmPasswordValidation(value, data) {
  if (data.newPassword !== data.confirmPassword || value === undefined) {
    return 'PRO_HOME_NEW_PASSWORD_ERROR_COINCIDENCE';
  }
}
